<div class="vis-wrapper cursor-default vis-web-search-criteria-page">
  <div class="vis-web-page-wrapper vis-web-position-relative vis-web-spinner-centered">
    <vis-web-spinner  [showSpinner]="isInputFieldDisabled('') == true"></vis-web-spinner>
    <div class="vis-row">
      <div class="vis-col-mobile-12 vis-col-tablet-12 vis-col-desktop-12 vis-web-margin-bottom-24-px">
        <h1 class="vis-heading">{{'pkb.imprestAccount.search-title' | translate}}</h1>
      </div>
    </div>

    <fieldset>
      <legend class="sr-only">{{'imprest.title.screenReader' | translate}}</legend>

      <div class="vis-row">
        <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4 form-group">
          <vis-web-input
            [id]="'typeAheadName'"
            [placeholder]="'Gatekeeper.displayName-label' | translate"
            [class]="'vis-web-width-100-percent vis-web-margin-right-16'"
            (keydown.enter)="updateObject()"
            [(value)]="name!">
          </vis-web-input>
        </div>
        <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4 form-group">
          <vis-web-typeahead [(selection)]="zipLocation"
                             [disabled]="isInputFieldDisabled('zipLocation')"
                             [id]="'whereInputField1'"
                             [dataUrl]="'/webresources/geodata/r4/municipals/politicalCommunities/$term'"
                             [placeholder]="'imprest.search.input.place.info' | translate"
                             [triggerLength]="3"
                             [validationFailureMessage]="'common.please.complete' | translate"
                             (selectionChange)="handleZipLocationChange($event)"
                             (enterAfterSelection)="updateObject()"></vis-web-typeahead>
          <!--DEBUG: {{_zipLocation | json}}-->
        </div>
        <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4 form-group">
          <vis-web-combo-box [(selectedSingleEntryKey)]="perimeter"
                             [disabled]="isInputFieldDisabled('perimeter')"
                             [id]="'selectPerimeter'"
                             [dataLocal]="perimeterValues"
                             [tabIndex]="0"
                             [title]="'imprest.perimeter' | translate"
                             [validationFailureMessage]="'common.please.complete' | translate"
                             [keepSelectionAfterReload]="true"></vis-web-combo-box>
        </div>
      </div>

      <div class="vis-row">
        <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4 form-group">
          <vis-web-combo-box [(selectedSingleEntryKey)]="insuranceModelType"
                             [disabled]="isInputFieldDisabled('insuranceModelType')"
                             [id]="'selectInsuranceModelType'"
                             [dataUrl]="insuranceModelUrl"
                             [title]="'imprest.insurancemodel' | translate"
                             [validationFailureMessage]="'common.please.complete' | translate"
                             [keepSelectionAfterReload]="true"></vis-web-combo-box>
        </div>
        <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4 form-group">
          <vis-web-combo-box [(selectedSingleEntryKey)]="medicalNetwork"
                             [disabled]="isInputFieldDisabled('medicalNetwork') || (insuranceModelType === 'MED_DIRECT') || (insuranceModelType === 'COMBI_CARE')"
                             [id]="'selectMedicalNetwork'"
                             [title]="'imprestaccount.doctor.network' | translate"
                             [dataUrl]="medicalNetworkUrl"
                             [selectOneDirect]="false"></vis-web-combo-box>
        </div>
        <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4 form-group">
          <vis-web-combo-box [(selectedSingleEntryKey)]="billerType"
                             [disabled]="isInputFieldDisabled('billerType')"
                             [id]="'selectBillerType'"
                             [title]="'imprestaccount.doctor.rsttype' | translate"
                             [dataUrl]="'/webresources/imprestAccount/r4/billerTypes'">
          </vis-web-combo-box>
        </div>
      </div>
      <div class="vis-row">
        <div class="vis-col-mobile-12 vis-col-tablet-12 vis-col-desktop-12 form-group">
          <vis-web-radio-group [(selection)]="keyDate"
                               [id]="'selectKeyDate'"
                               [dataObservable]="keyDatesObservable"
                               [keepSelectionAfterReload]="false"
                               [title]="'txt.refernceDate'"
                               [setFirstAsInitial]="true"></vis-web-radio-group>
        </div>
      </div>
    </fieldset>

    <div class="vis-row">
      <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4 form-group">
        <vis-web-button buttonClass="col-12 btn-primary col-12 btn-secondary" [id]="'btnSearch'"
                        (click)="updateObject()"
                        [additionalButtonClasses]="'vis-web-width-100-percent'"
                        [disabled]="isSaveButtonDisabled()">
          {{'imprest.button.search' | translate}}
        </vis-web-button>
      </div>
      <div class="vis-col-mobile-12 vis-col-tablet-12 vis-col-desktop-12 form-group">
        <a [id]="'btnReset'" class="actionable" (click)="deleteObject()">{{'imprest.button.reset' | translate}}</a>
      </div>
    </div>

    <!-- allfällige Suchvalidierungsmeldungen? -->
    <div class="row" *ngIf="searchState">
      <div class="col-sm">
        <ngb-alert type="warning" [dismissible]="false">
          {{searchState | translate}}
        </ngb-alert>
      </div>
    </div>
  </div>
</div>




